<gstar-residency-jurisdictions-grid
  [source]="residencyJurisdiction()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)" />
